
import { ShoppingBag } from "lucide-react";
import { Button } from "./ui/button";
import {
  Sheet,
  SheetContent,
  SheetHeader,
  SheetTitle,
  SheetTrigger,
} from "./ui/sheet";
import { useCartStore } from "@/store/cartStore";
import { CheckoutForm } from "./CheckoutForm";

export function CartSheet() {
  const items = useCartStore((state) => state.items);
  const total = items.reduce((acc, item) => acc + item.price * item.quantity, 0);

  return (
    <Sheet>
      <SheetTrigger asChild>
        <Button variant="outline" size="icon" className="relative">
          <ShoppingBag className="h-5 w-5" />
          {items.length > 0 && (
            <span className="absolute -top-2 -right-2 bg-primary text-primary-foreground w-5 h-5 rounded-full text-xs flex items-center justify-center">
              {items.length}
            </span>
          )}
        </Button>
      </SheetTrigger>
      <SheetContent className="w-full sm:max-w-lg flex flex-col">
        <SheetHeader>
          <SheetTitle>Medication Tray</SheetTitle>
        </SheetHeader>
        {items.length > 0 ? (
          <div className="flex-1 overflow-auto">
            <CheckoutForm />
          </div>
        ) : (
          <div className="flex flex-col items-center justify-center h-full">
            <ShoppingBag className="h-12 w-12 text-muted-foreground mb-4" />
            <p className="text-muted-foreground">Your medication tray is empty</p>
          </div>
        )}
      </SheetContent>
    </Sheet>
  );
}
